package pl.decks.personal.components.widgets.timeline

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember


@Composable
fun rememberHighlightRenderer(
    range: YearMonth.Range,
    highlights: List<TimelineHighlight>,
    defaultRenderer: MonthRenderer = MonthRenderer.default,
): MonthRenderer = remember(highlights) {
    val overrides = buildMap {
        highlights.forEach { highlight ->
            range.intersection(highlight.span)?.forEach { ym ->
                put(ym, highlight.monthRenderer to highlight.isOverridingMarker)
            }
        }
    }
    MonthRenderer(
        marker = { ym ->
            val (renderer, isOverriding) = overrides[ym] ?: (null to false)
            if (isOverriding) {
                renderer?.marker(ym)
            } else {
                defaultRenderer.marker(ym)
                renderer?.marker(ym)
            }
        },
        label = { ym ->
            val (renderer, _) = overrides[ym] ?: (null to false)
            if (renderer != null) renderer.label(ym)
            else defaultRenderer.label(ym)
        }
    )
}
